var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRisingBubblesGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      zIndex: 1,
      position: "relative",
      shapeRendering: "auto"
    },
    width: 2000,
    height: 2000,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1000,1000) scale(1,1) translate(-1000,-1000)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur-2csofo5qqt1-1",
    x: -1,
    y: -1,
    width: 3,
    height: 3
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur-2csofo5qqt1-2",
    x: -1,
    y: -1,
    width: 3,
    height: 3
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur-2csofo5qqt1-3",
    x: -1,
    y: -1,
    width: 3,
    height: 3
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 1311.2991395175127,
    cy: 0,
    transform: "translate(0 809.1305391507123)",
    r: 44.97086719255155,
    fill: "#00e3b4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-5.443735045715772s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2044.9708671925516;0 -44.97086719255155"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 523.8805882059663,
    cy: 0,
    transform: "translate(0 1039.9188099182588)",
    r: 40.261723896996024,
    fill: "#23f1b8",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-6.6032985467238925s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2040.261723896996;0 -40.261723896996024"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 813.7723537308714,
    cy: 0,
    transform: "translate(0 485.9193294786768)",
    r: 53.23397349126299,
    fill: "#29c4a4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-13.347201606385743s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2053.233973491263;0 -53.23397349126299"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5244610170438,
    cy: 0,
    transform: "translate(0 1585.0169944020274)",
    r: 28.003975388347936,
    fill: "#00e3b4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-11.09163236138459s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2028.003975388348;0 -28.003975388347936"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1240.1542793074043,
    cy: 0,
    transform: "translate(0 828.4353851003345)",
    r: 103.88183601730248,
    fill: "#00e3b4",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.7181950222582055s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2103.8818360173027;0 -103.88183601730248"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1122.0196015090175,
    cy: 0,
    transform: "translate(0 263.08226153155266)",
    r: 33.59083018472634,
    fill: "#29c4a4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-1.0764459776156743s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2033.5908301847264;0 -33.59083018472634"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.6593978495387,
    cy: 0,
    transform: "translate(0 1402.23880635951)",
    r: 55.094009053857214,
    fill: "#00e3b4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-7.681526768320253s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2055.094009053857;0 -55.094009053857214"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 841.2579247525853,
    cy: 0,
    transform: "translate(0 258.9979632734445)",
    r: 88.60839979378441,
    fill: "#23f1b8",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.6363153320002797s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2088.6083997937844;0 -88.60839979378441"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 688.4676167458417,
    cy: 0,
    transform: "translate(0 961.7365218232878)",
    r: 79.3734192593653,
    fill: "#29c4a4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-5.8146133680423s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2079.373419259365;0 -79.3734192593653"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 193.69861038170555,
    cy: 0,
    transform: "translate(0 1757.898018145979)",
    r: 29.964474351314493,
    fill: "#00e3b4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-15.76585248002008s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2029.9644743513145;0 -29.964474351314493"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1409.0568553606108,
    cy: 0,
    transform: "translate(0 1949.328178386504)",
    r: 66.3698201633488,
    fill: "#29c4a4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-7.224864160506554s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2066.369820163349;0 -66.3698201633488"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1892.624783681396,
    cy: 0,
    transform: "translate(0 1256.035545950835)",
    r: 59.917031668266134,
    fill: "#23f1b8",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.2643934447857199s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2059.917031668266;0 -59.917031668266134"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1581.692016385904,
    cy: 0,
    transform: "translate(0 496.8809878131419)",
    r: 80.08424421577594,
    fill: "#29c4a4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-1.2307015111702913s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2080.084244215776;0 -80.08424421577594"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1276.7570826946421,
    cy: 0,
    transform: "translate(0 957.8262275438644)",
    r: 28.062868329094954,
    fill: "#00e3b4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-9.48307376345638s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2028.062868329095;0 -28.062868329094954"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1467.1198446736375,
    cy: 0,
    transform: "translate(0 18.24112229868513)",
    r: 75.00873948695644,
    fill: "#23f1b8",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-8.942750059296698s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2075.0087394869565;0 -75.00873948695644"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1470.0337864072014,
    cy: 0,
    transform: "translate(0 600.1495777720858)",
    r: 45.968085713985275,
    fill: "#23f1b8",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-10.188665744566269s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2045.9680857139854;0 -45.968085713985275"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 900.6612817095396,
    cy: 0,
    transform: "translate(0 1097.791503010888)",
    r: 34.940543666196106,
    fill: "#29c4a4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.7374082562563489s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2034.9405436661962;0 -34.940543666196106"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 576.8396951807007,
    cy: 0,
    transform: "translate(0 1550.9815405000688)",
    r: 62.55442261476098,
    fill: "#00e3b4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-7.454711648274088s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2062.554422614761;0 -62.55442261476098"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 851.8671464099418,
    cy: 0,
    transform: "translate(0 1249.302133767337)",
    r: 87.65099016402789,
    fill: "#23f1b8",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-4.428705728288419s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2087.650990164028;0 -87.65099016402789"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 430.36625712657053,
    cy: 0,
    transform: "translate(0 1586.8445011595634)",
    r: 72.95384600069634,
    fill: "#29c4a4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-2.279021689155074s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2072.9538460006966;0 -72.95384600069634"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 719.349946187518,
    cy: 0,
    transform: "translate(0 156.71916181847223)",
    r: 87.5375875010625,
    fill: "#00e3b4",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-3.0137050786693536s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2087.5375875010627;0 -87.5375875010625"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1179.292958114765,
    cy: 0,
    transform: "translate(0 1624.8063592955723)",
    r: 74.20049923833804,
    fill: "#29c4a4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-7.015565053933559s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2074.200499238338;0 -74.20049923833804"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1859.2466279031864,
    cy: 0,
    transform: "translate(0 181.3704974237127)",
    r: 57.80763594899384,
    fill: "#23f1b8",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.29618459328004665s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2057.8076359489937;0 -57.80763594899384"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 752.1315584089509,
    cy: 0,
    transform: "translate(0 575.9098154538202)",
    r: 57.20334294848916,
    fill: "#29c4a4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-3.889915949611933s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2057.203342948489;0 -57.20334294848916"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1892.8781211480743,
    cy: 0,
    transform: "translate(0 525.9589179416105)",
    r: 53.13455092472019,
    fill: "#29c4a4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-4.125458174216479s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2053.1345509247203;0 -53.13455092472019"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1346.8337201526444,
    cy: 0,
    transform: "translate(0 986.0033989069797)",
    r: 48.17891655030979,
    fill: "#00e3b4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-18.749990620649516s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2048.1789165503096;0 -48.17891655030979"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1900.6052284803543,
    cy: 0,
    transform: "translate(0 522.7075404539065)",
    r: 72.49430315772261,
    fill: "#29c4a4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-7.873385847780334s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2072.4943031577227;0 -72.49430315772261"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.116938481513291,
    cy: 0,
    transform: "translate(0 519.0837481754054)",
    r: 67.67630813234234,
    fill: "#00e3b4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-8.80649435435741s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2067.6763081323425;0 -67.67630813234234"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 515.3185521067369,
    cy: 0,
    transform: "translate(0 1841.9644360373004)",
    r: 99.27207478014644,
    fill: "#00e3b4",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-2.2130760158930274s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2099.2720747801463;0 -99.27207478014644"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1078.7108127377435,
    cy: 0,
    transform: "translate(0 1489.4977205586013)",
    r: 80.49278238273442,
    fill: "#00e3b4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.495009241558948s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2080.4927823827343;0 -80.49278238273442"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 626.4911627425191,
    cy: 0,
    transform: "translate(0 1277.3162259529518)",
    r: 30.5436100244623,
    fill: "#29c4a4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-10.017398890805929s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2030.5436100244624;0 -30.5436100244623"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 494.20623596498723,
    cy: 0,
    transform: "translate(0 29.083929414003062)",
    r: 91.56111948664547,
    fill: "#00e3b4",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-3.3046768916976204s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2091.5611194866456;0 -91.56111948664547"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 63.55682172516141,
    cy: 0,
    transform: "translate(0 908.5713191098499)",
    r: 98.31899781682993,
    fill: "#23f1b8",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.8882558217540499s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2098.31899781683;0 -98.31899781682993"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 202.512840370912,
    cy: 0,
    transform: "translate(0 78.33324493649928)",
    r: 95.4822562589385,
    fill: "#23f1b8",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-1.6876103378565968s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2095.4822562589384;0 -95.4822562589385"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1610.5902191714026,
    cy: 0,
    transform: "translate(0 259.78786400429544)",
    r: 105.70310251764315,
    fill: "#23f1b8",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-1.2445951846505328s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2105.703102517643;0 -105.70310251764315"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 51.628693603246404,
    cy: 0,
    transform: "translate(0 62.6062993456129)",
    r: 72.92977136625896,
    fill: "#23f1b8",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-8.487063506833962s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2072.929771366259;0 -72.92977136625896"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 363.2452909070385,
    cy: 0,
    transform: "translate(0 1291.5942612504928)",
    r: 58.86369870303659,
    fill: "#23f1b8",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-4.5245633084637245s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2058.863698703037;0 -58.86369870303659"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 676.5205531740656,
    cy: 0,
    transform: "translate(0 1591.5191343082417)",
    r: 76.96176100903266,
    fill: "#29c4a4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.878850899664918s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2076.9617610090327;0 -76.96176100903266"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 343.4882608538659,
    cy: 0,
    transform: "translate(0 978.4180131832767)",
    r: 84.21056182564531,
    fill: "#00e3b4",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-2.592562530458638s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2084.2105618256455;0 -84.21056182564531"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1777.0009254055342,
    cy: 0,
    transform: "translate(0 384.11133735822654)",
    r: 48.42299024284168,
    fill: "#29c4a4",
    opacity: 0.36000000000000004
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-8.292174121991675s",
    dur: "20s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2048.4229902428415;0 -48.42299024284168"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1917.428432968416,
    cy: 0,
    transform: "translate(0 892.0111522858956)",
    r: 67.71422331542337,
    fill: "#23f1b8",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-5.209863997176331s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2067.714223315423;0 -67.71422331542337"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1192.3894698852043,
    cy: 0,
    transform: "translate(0 743.1621618875379)",
    r: 81.03615624120052,
    fill: "#23f1b8",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-2.536991150678164s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2081.0361562412004;0 -81.03615624120052"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1238.680356055517,
    cy: 0,
    transform: "translate(0 203.44529427380564)",
    r: 66.33719624871243,
    fill: "#29c4a4",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-7.633166531301667s",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2066.3371962487126;0 -66.33719624871243"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1709.593162757999,
    cy: 0,
    transform: "translate(0 787.9704007416545)",
    r: 99.38224463532548,
    fill: "#23f1b8",
    opacity: 0.7200000000000001
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    begin: "-0.7012171413199696s",
    dur: "6.666666666666666s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 2099.3822446353256;0 -99.38224463532548"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisingBubblesGreen);
export default __webpack_public_path__ + "static/media/rising-bubbles-green.55750df5445c044c43918ae3d6e50955.svg";
export { ForwardRef as ReactComponent };